"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiFilterCondition = exports.UiSearchInput = exports.UiFilterBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UiFilterBar = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 0 0 0 8px;\n\tbackground-color: #626262;\n\tborder-radius: 2px;\n"])));

exports.UiFilterBar = UiFilterBar;

var UiSearchInput = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 1;\n\n\t> input {\n\t\tflex: 1;\n\t\tmargin-left: 10px;\n\t\tcolor: #fff;\n\t\tbackground-color: transparent;\n\t\tborder: none;\n\t\toutline: none;\n\t\tcaret-color: #fff;\n\t}\n"])));

exports.UiSearchInput = UiSearchInput;

var UiFilterCondition = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));

exports.UiFilterCondition = UiFilterCondition;